import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=18f2e9be&scoped=true&"
import script from "./NewsList.vue?vue&type=script&lang=ts&"
export * from "./NewsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2e9be",
  null
  
)

export default component.exports